/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { Route, Switch } from 'react-router-dom';
import { RouteErrorBoundary } from '@features/error';
import { AppRouteInterface } from '@g17eco/types/routes';
import { AppLayout } from '../../../layout/AppLayout';
import Header from '@features/header';
import UTrModal from '@features/utr-modal';
import { AppHeader } from '@features/header/AppHeader';
import AssuranceTrackerLogo from '../../../images/apps/Assurance_Tracker_logo.svg';
import AssuranceList from '@apps/assurance/components/assurance-list/assurance-list';
import { useSelector } from 'react-redux';
import { getCurrentUser } from '@selectors/user';
import NotAuthorised from '@routes/not-authorised';
import { useGetUserOrganizationQuery } from '@api/assurance';
import { assuranceRouteEntry, assuranceOtherRoutes } from './routes';
import { getHydratedRoutes } from '../../../constants/routeComponents';

const assuranceAppRoute: AppRouteInterface = {
  appName: 'Assurance Tracker',
  appIcon: AssuranceTrackerLogo,
  routes: [
    assuranceOtherRoutes.ASSURANCE_PORTFOLIO
  ],
}
const routes = getHydratedRoutes(assuranceOtherRoutes);

export const AssuranceRoute = () => {

  const { data: organization } = useGetUserOrganizationQuery();
  const currentUser = useSelector(getCurrentUser);

  // This check will likely be redundant because now we will show the brochure if users have no access
  const hasOrganization = Boolean(currentUser?.organizationId) || organization;

  return (
    <RouteErrorBoundary>
      <AppLayout Header={
        <Header>
          <AppHeader
            appRoute={assuranceAppRoute}
            route={assuranceRouteEntry} />
        </Header>
      }>
        {hasOrganization ?
          (
            <Switch>
              {Object.entries(routes).map(([_key, route]) => {
                return <Route
                  key={`route_${route.id}`}
                  {...route}
                  exact={route.exact ?? false} />
              })}
              <Route>
                <AssuranceList />
              </Route>
            </Switch>
          ) : <NotAuthorised />
        }
        <UTrModal />
      </AppLayout>
    </RouteErrorBoundary>
  )
}
